export const PageSectionKeys = {
    home: 'home',
    trustHub: 'trustHub',
    trustHubPortal: 'trustHubPortal',
    gravityGrc: 'gravityGrc',
    consulting: 'consulting',
    about: 'about',
    contacts: 'contacts',
};

export const PageSections = [
    {
        displayName: 'Services',
        key: PageSectionKeys.consulting,
    },
    {
        displayName: 'TrustHUB',
        key: PageSectionKeys.trustHub,
    },
    {
        displayName: 'Gravity GRC',
        key: PageSectionKeys.gravityGrc,
    },
    {
        displayName: 'About',
        key: PageSectionKeys.about,
    },
    {
        displayName: 'Contacts',
        key: PageSectionKeys.contacts,
    },
];

export const CONTACT_EMAIL = 'info@gravity-security.com';
export const PLATFORM_URL = 'https://platform.gravitygrc.com/login';